<div id="homebackground">
  <div id="homebox" class="home-box">
      <div class="home-margin-box">
          <div>
              <img src="assets/images/Logo_Home.png" />
          </div>
          <div class="mt-2">
              <p>{{ p1 }}</p>
              <p>{{ p2 }}</p>
          </div>
      </div>
  </div>
</div>
